<template>

<v-dialog v-model="dialog" width="900px">
  <v-card class="dummy" style="height: 800px">
    <p class=".title ma-2">Show location of {{huis.huis_code}} </p>
    <v-form ref="updAddress" v-model="updAddressValid">
    
  <GmapAutocomplete @place_changed='setPlace' placeholder="Enter the address of the accommodation" size="80"/>

  <gmap-map
      :center="center"
      :zoom=huis.zoom
      style="width:100%;  height: 700px;"
    >
      <gmap-marker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        @click="center=m.position"
        :draggable="true" 
        @drag="updateCoordinates" 
      ></gmap-marker>
    </gmap-map>
    
    

    </v-form>
    <v-card-actions class="card-actions">
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="updGps" :disabled="!positionChanged" :loading="loading">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>

export default {
  components: {
  },
  data() { 
    return {
      dialog: false,
      updAddressValid: false,
      huis_encrid: null,
      googleAddress: '',
      coordinates: {},
      zoom: 18,
      positionChanged: false,
      huis: {},
      center: { lat: 45.508, lng: -73.587 },
      markers: [],
      places: [],
      currentPlace: null,
      loading: false,
    }
  },
  methods: {
    open(huis_encrid) {
      this.$axios
        .post("ares/json/ares/huis/getHuisToShowMap.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuisToShowMap"
          },
          getHuisToShowMap: {
            huis_encrid: huis_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.huis = res.data.getHuisToShowMap;
            this.center.lat = this.huis.huis_latitude;
            this.center.lng = this.huis.huis_longitude; 
            this.dialog = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
        this.geolocate();
        this.addMarker();
    },

    updateCoordinates(location) {
            this.coordinates = {
                lat: location.latLng.lat(),
                lng: location.latLng.lng(),
            };
            this.positionChanged = true;
        },

    setPlace(place) {       
       this.currentPlace = place;
       const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
          
        };
       this.markers.push({ position: marker });
        this.places.push(this.currentPlace);
        this.center = marker;
        this.currentPlace = null;
    },

    addMarker() {
      
        const marker = {
          /*
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
          */
          lat: this.center.lat,
          lng: this.center.lng
        };
        this.markers.push({ position: marker });
        this.places.push(this.currentPlace);
        this.center = marker;
        this.currentPlace = null;
    
    },
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },
    
    updGps() { 
      this.loading = true;
      this.$axios
        .post("ares/json/ares/huis/saveHuisGps.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveHuisGps"
          },
          saveHuisGps: {
            huis_encrid: this.huis.huis_encrid,
            huis_longitude: this.coordinates.lng,
            huis_latitude: this.coordinates.lat
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             //this.$router.reload('/huis/onHuis/' + res.data.saveHuisGps.huis_encrid);            
             this.$emit('updateData');
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveHuisGps.text,
              color: res.data.saveHuisGps.color
            }); 
            this.dialog = false;
          }
          this.loading = false;
        })
    }
        
  }
}
</script>

